
import { defineComponent, PropType } from 'vue'
import type { OtherIntegrationItem } from '@/helpers/marketplace/otherIntegrations'
import UxIcon from './UxIcon.vue'
import { DEFAULT_OTHER_INTEGRATIONS_TITLE } from '@/helpers/marketplace/otherIntegrations'

export default defineComponent({
    components: { UxIcon },
    props: {
        items: {
            type: Array as PropType<OtherIntegrationItem[]>,
            default: () => [],
        },
        title: {
            type: String,
            default: DEFAULT_OTHER_INTEGRATIONS_TITLE,
        },
    },
})
